// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"18":"lg-2","173":"lg-3","388":"lg-1","440":"lg-4","441":"lg-10","453":"lg-11","478":"lg-6","558":"lg-8","637":"lg-5","730":"lg-9","868":"lg-7","963":"lg-0"}[chunkId] || chunkId) + ".js";
};